@if (currentSiret(); as siret) {
  <div class="relative">
    <button
      type="button"
      id="company-selector-trigger"
      [attr.aria-expanded]="menuOpen()"
      aria-haspopup="listbox"
      aria-label="Changer d entreprise"
      (click)="toggleMenu($event)"
      class="w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 flex items-center gap-3 hover:bg-gray-100 transition-colors text-left cursor-pointer"
    >
      <div class="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center shrink-0">
        <span class="material-symbols-outlined text-white text-[18px] leading-none">apartment</span>
      </div>
      <div class="flex-1 min-w-0">
        <div class="text-xs font-semibold text-gray-900 truncate">
          {{ selectedCompany()?.nomEntreprise || 'Entreprise' }}
        </div>
        <div class="text-[10px] text-gray-500 truncate font-mono">
          {{ selectedCompany()?.siretFormatte || siret }}
        </div>
      </div>
      <span class="material-symbols-outlined text-gray-500 text-[18px] shrink-0" [class.rotate-180]="menuOpen()">expand_more</span>
    </button>

    @if (menuOpen()) {
      <div
        class="absolute left-0 right-0 top-full z-50 mt-1 rounded-xl border border-gray-200 bg-white shadow-lg py-1 max-h-64 overflow-y-auto"
        role="listbox"
        aria-labelledby="company-selector-trigger"
      >
        @for (c of companies(); track c.siret) {
          <div class="w-full px-3 py-2.5 flex items-center gap-2 text-left hover:bg-gray-50">
            <div class="flex-1 min-w-0">
              <button
                type="button"
                role="option"
                [attr.aria-selected]="c.siret === siret"
                (click)="selectCompany(c.siret)"
                class="w-full text-left cursor-pointer border-0 bg-transparent p-0"
              >
                <div class="text-sm truncate" [class.font-semibold]="c.siret === siret" [class.text-secondary]="c.siret === siret">
                  {{ c.nomEntreprise }}
                </div>
                <div class="text-[10px] text-gray-500 font-mono">{{ c.siretFormatte }}</div>
              </button>
            </div>
            @if (c.siret === siret) {
              <span class="material-symbols-outlined text-secondary text-[18px] shrink-0">check</span>
            }
            <button
              type="button"
              class="text-gray-400 hover:text-red-600 transition-colors cursor-pointer"
              title="Supprimer cette entreprise"
              (click)="removeCompany(c, $event)"
            >
              <span class="material-symbols-outlined text-[16px] leading-none">delete</span>
            </button>
          </div>
        }
        <div class="border-t border-gray-100 my-1"></div>
        <button
          type="button"
          (click)="openAddCompany()"
          class="w-full px-3 py-2.5 flex items-center gap-2 text-left text-sm font-medium text-secondary hover:bg-secondary/10 cursor-pointer border-0 bg-transparent"
        >
          <span class="material-symbols-outlined text-[18px]">add</span>
          Ajouter une entreprise
        </button>
      </div>
    }
  </div>
} @else if (companies().length) {
  <div class="relative">
    <button
      type="button"
      id="company-selector-trigger"
      [attr.aria-expanded]="menuOpen()"
      aria-haspopup="listbox"
      (click)="toggleMenu($event)"
      class="w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 flex items-center gap-3 hover:bg-gray-100 transition-colors text-left cursor-pointer"
    >
      <div class="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center shrink-0">
        <span class="material-symbols-outlined text-white text-[18px] leading-none">apartment</span>
      </div>
      <div class="flex-1 min-w-0">
        <div class="text-xs font-semibold text-gray-900 truncate">Mes entreprises</div>
        <div class="text-[10px] text-gray-500">Selectionner une societe</div>
      </div>
      <span class="material-symbols-outlined text-gray-500 text-[18px] shrink-0">expand_more</span>
    </button>
    @if (menuOpen()) {
      <div
        class="absolute left-0 right-0 top-full z-50 mt-1 rounded-xl border border-gray-200 bg-white shadow-lg py-1 max-h-64 overflow-y-auto"
        role="listbox"
      >
        @for (c of companies(); track c.siret) {
          <div class="w-full px-3 py-2.5 flex items-center gap-2 hover:bg-gray-50">
            <button
              type="button"
              (click)="selectCompany(c.siret)"
              class="flex-1 text-left text-sm cursor-pointer border-0 bg-transparent truncate p-0"
            >
              {{ c.nomEntreprise }}
              <span class="block text-[10px] text-gray-500 font-mono">{{ c.siretFormatte }}</span>
            </button>
            <button
              type="button"
              class="text-gray-400 hover:text-red-600 transition-colors cursor-pointer"
              title="Supprimer cette entreprise"
              (click)="removeCompany(c, $event)"
            >
              <span class="material-symbols-outlined text-[16px] leading-none">delete</span>
            </button>
          </div>
        }
        <div class="border-t border-gray-100 my-1"></div>
        <button
          type="button"
          (click)="openAddCompany()"
          class="w-full px-3 py-2.5 flex items-center gap-2 text-left text-sm font-medium text-secondary hover:bg-secondary/10 cursor-pointer border-0 bg-transparent"
        >
          <span class="material-symbols-outlined text-[18px]">add</span>
          Ajouter une entreprise
        </button>
      </div>
    }
  </div>
} @else {
  <button
    type="button"
    id="company-selector-trigger"
    (click)="openAddCompany()"
    class="w-full rounded-xl border border-dashed border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-600 hover:bg-gray-100 cursor-pointer"
  >
    Ajouter une entreprise
  </button>
}
